function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/* globals angular, EventSource */
(function () {
  'use strict';

  angular.module('wsLrs.services').factory('Workflows', ['Resource', '$http', function (Resource, $http) {
    var resource = new Resource("/workflows", false);
    return _.extend(resource, {
      testRun: function testRun(workflowId, eventCallback, errorCallback, sourceClosedCallback) {
        var source = new EventSource(resource.__apiUrl() + workflowId + '/debug');
        source.addEventListener("workflow:debug:update", eventCallback);
        source.onerror = function (error) {
          if (source.readyState !== source.OPEN) {
            source.close();
            sourceClosedCallback();
          } else {
            errorCallback(error);
          }
        };
      },
      getAllJobs: function getAllJobs() {
        var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return $http.get(resource.__apiUrl() + 'jobs', cfg);
      }
    });
  }]).factory('WorkflowsRegistry', ['Workflows', '$q', function (Workflows, $q) {
    return {
      workflows: [],
      create: function create(workflow) {
        var _this = this;
        return $q(function (resolve, reject) {
          Workflows.save(workflow).then(function (response) {
            _this.workflows.push(workflow);
            resolve(response);
          }, function (err) {
            reject(err);
          });
        });
      },
      get: function get() {
        var _this2 = this;
        var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
        return this.getAll().then(function (_ref) {
          var results = _ref.results;
          return {
            count: _this2.workflows.length,
            results: results.slice(offset).slice(0, limit)
          };
        });
      },
      getAll: function getAll() {
        var self = this;
        return $q(function (resolve) {
          if (self.workflows.length === 0) {
            Workflows.get().then(function (response) {
              self.workflows = response.results;
              resolve(response);
            });
          } else {
            resolve({
              count: self.workflows.length,
              results: self.workflows
            });
          }
        });
      },
      getOne: function getOne(workflowId) {
        var self = this;
        return $q(function (resolve, reject) {
          self.getAll().then(function (_ref2) {
            var results = _ref2.results;
            var match = results.filter(function (w) {
              return w.id === parseInt(workflowId);
            });
            if (match && match.length === 1) {
              resolve(match[0]);
            } else {
              reject("No workflow found for id: ".concat(workflowId));
            }
          });
        });
      },
      update: function update(workflow) {
        var self = this;
        return $q(function (resolve, reject) {
          Workflows.save(workflow).then(function (response) {
            resolve(response);
            // Update the workflow cache with the new workflow we just updated
            self.workflows = [].concat(_toConsumableArray(self.workflows.filter(function (w) {
              return w.id !== workflow.id;
            })), [workflow]).sort(function (a, b) {
              return a.id > b.id ? 1 : -1;
            });
          }, function (err) {
            reject(err);
          });
        });
      },
      deleteOne: function deleteOne(workflowId) {
        var self = this;
        return $q(function (resolve, reject) {
          Workflows.remove(workflowId).then(function () {
            self.workflows = self.workflows.filter(function (w) {
              return w.id !== workflowId;
            });
            resolve();
          }, function (err) {
            reject(err);
          });
        });
      },
      /**
       * Used primarily when changing orgs or signing out
       */
      clearCache: function clearCache() {
        var self = this;
        self.workflows = [];
      },
      /**
       * When a share is created, deleted, or a report is deleted, we should refresh the workflows
       * cache to make sure nothing has changed and all workflows are up-to-date.
       */
      refresh: function refresh() {
        var self = this;
        self.clearCache();
        self.getAll();
      }
    };
  }]);
})();
